import { useQuery } from '@tanstack/react-query';
import { fetchExperience } from 'flux/clients/experiences';
import { useCurrencyContext } from '~/context/CurrencyContext';
import { useI18n } from '~/stores/i18n';

export type UseExperienceOptions = {
  addLiveParam?: boolean;
};

function useExperience(experienceId: string, options?: UseExperienceOptions) {
  const { state } = useCurrencyContext();
  const currency = state.currency;
  const { lang } = useI18n();

  return useQuery({
    queryFn: () =>
      fetchExperience(experienceId, lang, currency, options?.addLiveParam),
    queryKey: [
      'experience',
      experienceId,
      currency,
      lang,
      options?.addLiveParam,
    ],
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!experienceId,
    retry: 0,
  });
}

export default useExperience;
